import { render, staticRenderFns } from "./TextAreaWithSave.vue?vue&type=template&id=fe1f0e68&scoped=true&"
import script from "./TextAreaWithSave.vue?vue&type=script&lang=js&"
export * from "./TextAreaWithSave.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaWithSave.vue?vue&type=style&index=0&id=fe1f0e68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1f0e68",
  null
  
)

export default component.exports